import pt_BR from "./pt_BR";
import en_US from "./en_US";
import es_ES from "./es_ES";

// traduz texto do campo correspondente ao idioma passado
export function tradutor(idioma, campo) {
    // resgata idiomas
    const idiomas = {
        pt_BR,
        en_US,
        es_ES
    }

    // resgata o campo do idioma passado
    const campoIdioma = idiomas[idioma || pt_BR][campo] ?? '';

    // retorna campo do idioma correspondente
    return campoIdioma
}